import { IssueStatus, VehicleAuditIssueType } from "../../../../logic/api";
import { TFunction } from "i18next";

import vehicleIssueStyles from "./styles";

export const getIssueTypeLabel = (issueType: string | VehicleAuditIssueType, t: TFunction): string => {
  let issueTypeName: string;

  if (typeof issueType === "number") {
    issueTypeName = VehicleAuditIssueType[issueType];
  } else {
    issueTypeName = issueType;
  }

  const translationKey = `locations.vehicleIssues.types.${issueTypeName}`;
  const translated = t(translationKey);

  return translated === translationKey ? issueTypeName : translated;
};

export const getStatusLabel = (status: IssueStatus, t: TFunction): string => {
  switch (status) {
    case IssueStatus.Open:
      return t("locations.vehicleIssues.status.open");
    case IssueStatus.Assigned:
      return t("locations.vehicleIssues.status.assigned");
    case IssueStatus.Resolved:
      return t("locations.vehicleIssues.status.resolved");
    case IssueStatus.NoAction:
      return t("locations.vehicleIssues.status.noAction");
    default:
      return t("general.unknown");
  }
};

export const getStatusColor = (status: IssueStatus): string => {
  const { colors } = vehicleIssueStyles;

  switch (status) {
    case IssueStatus.Open:
      return colors.red;
    case IssueStatus.Assigned:
      return colors.amber;
    case IssueStatus.Resolved:
      return colors.darkGreen;
    case IssueStatus.NoAction:
      return colors.darkGray;
    default:
      return colors.darkGray;
  }
};

export const getStatusColorMui = (status: IssueStatus): "error" | "warning" | "success" | "default" => {
  switch (status) {
    case IssueStatus.Open:
      return "error";
    case IssueStatus.Assigned:
      return "warning";
    case IssueStatus.Resolved:
      return "success";
    case IssueStatus.NoAction:
      return "default";
    default:
      return "default";
  }
};